function JourneyStage({ stage, isActive, isComplete, isLast }) {
  const getIcon = () => {
    switch (stage.key) {
      case 'discover':
        return (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        )
      case 'reserved':
        return (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )
      case 'under_contract':
        return (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        )
      case 'unconditional':
        return (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        )
      case 'under_construction':
        return (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        )
      case 'ready_to_settle':
        return (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
          </svg>
        )
      case 'settled':
        return (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
        )
      default:
        return null
    }
  }

  return (
    <div className="flex-1 relative">
      <div className="flex flex-col items-center">
        <div
          className={`relative z-10 w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500 ${
            isComplete
              ? 'bg-success-600 text-white shadow-lg shadow-success-200'
              : isActive
              ? 'bg-primary-600 text-white shadow-lg shadow-primary-200 animate-pulse'
              : 'bg-neutral-100 text-neutral-400'
          }`}
        >
          {getIcon()}
          {isComplete && (
            <div className="absolute -top-1 -right-1 w-6 h-6 bg-success-700 rounded-full flex items-center justify-center">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          )}
        </div>

        <div className="mt-3 text-center">
          <p
            className={`text-sm font-semibold mb-1 transition-colors ${
              isActive || isComplete ? 'text-neutral-900' : 'text-neutral-500'
            }`}
          >
            {stage.label}
          </p>
          <p className="text-xs text-neutral-500 max-w-[120px]">
            {stage.description}
          </p>
        </div>
      </div>

      {!isLast && (
        <div
          className={`absolute top-8 left-[calc(50%+32px)] right-[calc(-50%+32px)] h-0.5 transition-all duration-500 ${
            isComplete ? 'bg-success-600' : 'bg-neutral-200'
          }`}
        />
      )}
    </div>
  )
}

export function PurchaseJourneyVisual({ currentStage = 'discover' }) {
  const stages = [
    {
      key: 'discover',
      label: 'Discover',
      description: 'Browse and follow projects',
    },
    {
      key: 'reserved',
      label: 'Reserved',
      description: 'Unit on hold for you',
    },
    {
      key: 'under_contract',
      label: 'Under Contract',
      description: 'Agreement in progress',
    },
    {
      key: 'unconditional',
      label: 'Unconditional',
      description: 'Fully committed',
    },
    {
      key: 'under_construction',
      label: 'Construction',
      description: 'Building in progress',
    },
    {
      key: 'ready_to_settle',
      label: 'Ready',
      description: 'Prepare for settlement',
    },
    {
      key: 'settled',
      label: 'Settled',
      description: 'Keys in hand',
    },
  ]

  const currentIndex = stages.findIndex(s => s.key === currentStage)

  return (
    <div className="bg-gradient-to-br from-white to-neutral-50 rounded-2xl border border-neutral-200 p-8 overflow-x-auto">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-neutral-900 mb-2">
          Your Purchase Journey
        </h3>
        <p className="text-sm text-neutral-600">
          Track your progress from discovery to settlement
        </p>
      </div>

      <div className="flex gap-0 min-w-max">
        {stages.map((stage, index) => (
          <JourneyStage
            key={stage.key}
            stage={stage}
            isActive={index === currentIndex}
            isComplete={index < currentIndex}
            isLast={index === stages.length - 1}
          />
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-neutral-200">
        <div className="flex items-start gap-3 text-sm">
          <svg className="w-5 h-5 text-primary-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <p className="text-neutral-700 font-medium mb-1">
              {currentStage === 'discover' && 'Start by following projects that interest you'}
              {currentStage === 'reserved' && 'Your reservation is active. Proceed to contract when ready.'}
              {currentStage === 'under_contract' && 'Work with your solicitor to complete the agreement'}
              {currentStage === 'unconditional' && 'Great! Now track construction progress until completion'}
              {currentStage === 'under_construction' && 'Stay updated with project milestones and photos'}
              {currentStage === 'ready_to_settle' && 'Prepare for final inspections and settlement'}
              {currentStage === 'settled' && 'Congratulations on your new home!'}
            </p>
            <p className="text-neutral-500 text-xs">
              {currentStage === 'discover' && 'Browse available projects and click the heart icon to follow'}
              {currentStage === 'reserved' && 'You have limited time to proceed to contract or withdraw'}
              {currentStage === 'under_contract' && 'Your agreement will be reviewed by both parties'}
              {currentStage === 'unconditional' && 'Construction updates will appear in your dashboard'}
              {currentStage === 'under_construction' && 'Estimated completion dates are shown on each project'}
              {currentStage === 'ready_to_settle' && 'Your solicitor will coordinate the final steps'}
              {currentStage === 'settled' && 'Enjoy your new home and thank you for using Beaver'}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
